import { createContext } from 'react';

const beforeInstallPromptContext = createContext();

export default beforeInstallPromptContext;
